import { SystemEvent } from '../enum';
import { ExternalBotEvent } from '../enum/ExternalBotEvent';
import {
  SystemOptionEvent,
  ResolutionEvent,
  NoneOfTheAboveEvent,
  ArticleExpandedEvent,
  RollbackEvent,
  BaseEvent,
  AltResolutionEvent,
  ArticleInteractionExternEvent,
  CancelSupportRequestExternEvent,
  BaseExternalEvent,
  ActionSelectedEvent,
  ArticleListNavigationEvent,
  PreSupportSelectionEvent,
  AlternativeActionSelectedEvent,
  UserInputSubmittedTransactionEvent,
  ApplyMetadataAutomationExternEvent,
  PredictiveSuggestionSelectionEvent,
  UserMessageForAIEvent,
  RateAiResponseEvent,
  UserInputSubmittedTransactionForAiEvent,
  ResumeAIChatEvent,
  UserLoginEvent,
  StartSelectedEntityFlowEvent,
  GuestLoginEvent,
  UserFileForAIEvent
} from '../types';

export function isOptionEvent(event: any): event is SystemOptionEvent {
  return event?.type === SystemEvent.LIST_OPTION_SELECTED;
}

export function isResolutionEvent(event: any): event is ResolutionEvent {
  return event?.type === SystemEvent.USER_RESOLUTION_SELECTED;
}

export function isNoneOfTheAboveEvent(event: any): event is NoneOfTheAboveEvent {
  return event?.type === SystemEvent.NONE_OF_THE_ABOVE_SELECTED;
}

export function isArticleExpandedEvent(event: any): event is ArticleExpandedEvent {
  return event?.type === SystemEvent.ARTICLE_PREVIEW_EXPANDED;
}

export function isRollbackEvent(event: any): event is RollbackEvent {
  return event?.type === SystemEvent.USER_ROLLBACK;
}

export function isisAltResolutionEvent(event: any): event is AltResolutionEvent {
  return event?.type === SystemEvent.ALTERNATIVE_ACTION;
}

export function isActionSelectedEvent(event: any): event is ActionSelectedEvent {
  return event?.type === SystemEvent.ACTION_SELECTED;
}

export function isArticleListNavigationEvent(event: any): event is ArticleListNavigationEvent {
  return event?.type === SystemEvent.ARTICLE_LIST_NAVIGATION;
}

export function isArticleInteractionEvent(event: any): event is ArticleInteractionExternEvent {
  return event?.type === ExternalBotEvent.ARTICLE_PAGE_INTERACTION;
}

export function isCancelSupportRequestEvent(event: any): event is CancelSupportRequestExternEvent {
  return event?.type === ExternalBotEvent.CANCEL_SUPPORT_REQUEST;
}

export function isApplyMetadataAutomationEvent(event: any): event is ApplyMetadataAutomationExternEvent {
  return event?.type === ExternalBotEvent.APPLY_METADATA_AUTOMATION;
}

export function isUserInputSubmittedTransactionEvent(event: any): event is UserInputSubmittedTransactionEvent {
  return event?.type === ExternalBotEvent.USER_SUBMIT_INPUT_TRANSACTION;
}

export function isUserInputSubmittedTransactionForAiEvent(
  event: any
): event is UserInputSubmittedTransactionForAiEvent {
  return event?.type === ExternalBotEvent.USER_SUBMIT_INPUT_TRANSACTION_FOR_AI;
}

export function isUserMessageForAIEvent(event: any): event is UserMessageForAIEvent {
  return event?.type === ExternalBotEvent.USER_MESSAGE_FOR_AI;
}

export function isUserFileForAIEvent (event: any): event is UserFileForAIEvent {
  return event?.type === ExternalBotEvent.USER_FILE_FOR_AI;
}

export function isRateAiResponseEvent (event: any): event is RateAiResponseEvent {
  return event?.type === SystemEvent.RATE_AI_RESPONSE;
}

export function isExternalEvent(event: any): event is BaseExternalEvent {
  return ((event?.type as string) || '').startsWith('external.sys');
}

export function isSystemEvent(event: any): event is BaseEvent {
  return ((event?.type as string) || '').startsWith('sys');
}

export function isPreSupportPromptSelectionEvent(event: any): event is PreSupportSelectionEvent {
  return event?.type === SystemEvent.PRE_SUPPORT_SELECTION;
}

export function isAlternativeActionEvent(event: any): event is AlternativeActionSelectedEvent {
  return event?.type === SystemEvent.ALTERNATIVE_ACTION;
}

export function isPredictiveSuggestionSelectionEvent(event: any): event is PredictiveSuggestionSelectionEvent {
  return event?.type === SystemEvent.PREDICTIVE_SUGGESTION_SELECTION;
}

export function isResumeAIChat(event: any): event is ResumeAIChatEvent {
  return event?.type === ExternalBotEvent.RESUME_AI_CHAT;
}

export function isUserLoginEvent(event: any): event is UserLoginEvent {
  return event?.type === ExternalBotEvent.USER_LOGIN;
}

export function isGuestLoginEvent (event: any): event is GuestLoginEvent {
  return event?.type === ExternalBotEvent.GUEST_LOGIN;
}

export function isStartSelectedEntityFlowEvent(event: any): event is StartSelectedEntityFlowEvent {
  return event?.type === ExternalBotEvent.START_SELECTED_ENTITY_FLOW;
}
